
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/05c85fc7da3c56350a98e06d6933007c/521ce2f64a3197aeacbf96106048b2bd.jpeg" 
              alt="Esfera Records" 
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="font-['Poppins',sans-serif] text-sm text-gray-300 leading-relaxed">
              Producción de eventos, artistas profesionales y servicios de audio de primera calidad. Juntos al éxito.
            </p>
          </div>

          <div>
            <h3 className="font-['Montserrat',sans-serif] text-base font-bold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('inicio')}
                  className="font-['Poppins',sans-serif] text-sm text-gray-300 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('servicios')}
                  className="font-['Poppins',sans-serif] text-sm text-gray-300 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('artistas')}
                  className="font-['Poppins',sans-serif] text-sm text-gray-300 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  Artistas
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('testimonios')}
                  className="font-['Poppins',sans-serif] text-sm text-gray-300 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  Testimonios
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-['Montserrat',sans-serif] text-base font-bold mb-4">Servicios</h3>
            <ul className="space-y-3">
              <li className="font-['Poppins',sans-serif] text-sm text-gray-300">Producción de Eventos</li>
              <li className="font-['Poppins',sans-serif] text-sm text-gray-300">Artistas y Grupos</li>
              <li className="font-['Poppins',sans-serif] text-sm text-gray-300">Renta de Sonido</li>
              <li className="font-['Poppins',sans-serif] text-sm text-gray-300">Estudio de Grabación</li>
            </ul>
          </div>

          <div>
            <h3 className="font-['Montserrat',sans-serif] text-base font-bold mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-pink-400 mt-1 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span className="font-['Poppins',sans-serif] text-sm text-gray-300">Flores Magón, Cuernavaca, Morelos</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-pink-400 mt-1 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <div className="font-['Poppins',sans-serif] text-sm text-gray-300">
                  <div>Manager: 777-114-3440</div>
                  <div>Oficina: 551-173-3326</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-pink-400 mt-1 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span className="font-['Poppins',sans-serif] text-sm text-gray-300">vicmagico@gmail.com</span>
              </li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a 
                href="https://www.facebook.com/Americanmusicv/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-lg hover:bg-teal-600 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a 
                href="https://instagram.com/esferarecords" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-lg hover:bg-teal-600 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a 
                href="https://wa.me/5217771143440" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-lg hover:bg-teal-600 transition-all cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-['Poppins',sans-serif] text-sm text-gray-400">
              © 2024 Esfera Records. Todos los derechos reservados.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-['Poppins',sans-serif] text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
